import { useApolloClient } from '@apollo/client'

import { PayrollRunStatus } from 'modules/compensations/lib/constants'

/**
 * Hook that provides a function to optimistically update the status of a
 * CompensationsPayrollRun to CALCULATION in the Apollo cache.
 */
export const useOptimisticStatusUpdate = () => {
  const client = useApolloClient()

  /**
   * Updates the status of a CompensationsPayrollRun in the cache
   * @param id - The ID of the PayrollRun to update
   * @param status - The status to set (defaults to CALCULATION)
   */
  const updatePayrollRunStatus = (id: string, status: string = PayrollRunStatus.CALCULATION) => {
    client.cache.modify({
      id: client.cache.identify({
        __typename: 'CompensationsPayrollRun',
        id,
      }),
      fields: {
        status() {
          return status
        },
      },
    })
  }

  return { updatePayrollRunStatus }
}
